import { Button, Modal, Popover, Tooltip, Carousel } from "bootstrap";
var myCarousel = document.querySelector('#hero-slideshow');
if (myCarousel) {
  var carousel = new Carousel(myCarousel);
}

var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
  return new Tooltip(tooltipTriggerEl)
});

//loop through full width ads
let fullWidthAds = document.getElementsByClassName("fullWidthAdImg");
var position = fullWidthAds.length - 1;

function fullWidthSwitch() {
  if (fullWidthAds && fullWidthAds.length > 0) {
    if (!fullWidthAds[position].classList.contains("d-none")) {
      fullWidthAds[position].classList.add("d-none");
    }
    if (position == fullWidthAds.length - 1) position = -1;
    position++;
    fullWidthAds[position].classList.remove("d-none");
    setTimeout(fullWidthSwitch, 9000);
  }
}


document.addEventListener('DOMContentLoaded',() => {

  
  //-- START - COLLAPSE HEADER onScroll

  document.getElementById('content').style.paddingTop = document.getElementsByTagName('header')[0].offsetHeight+'px';

  // set variables mainly for scroll, but using for mobile-related stuff too 
  let latestKnownScrollY = 0, 
      rpos = false,
      topNavAndHeaderHeight = document.getElementById('nav-row').scrollHeight,
      navSearchHeight = document.getElementById('nav-search').scrollHeight,
      navSearchOuter = document.getElementById('nav-search-outer'),
      mobileHeaderHeight = document.getElementById('mobile-banner-outer').scrollHeight,
      searchIconHeaderAds = document.getElementById('search-icon-header-ads'),
      viewableHeight = document.body.clientHeight,
      viewableWidth = document.body.clientWidth,
      viewableHeightPc = 100 / viewableHeight,
      navScrollDiff = 0,
      screenWidth = 768;
  
  const doResize = () => {
    // if (window.innerWidth > 768) {
      window.addEventListener('scroll', onScroll, false);
    // }
    
    
    viewableWidth = document.body.clientWidth;

    if (viewableWidth <= screenWidth) {
      //set search wrapper div to display block
      navSearchOuter.setAttribute('style','display:block !important;height:0px');
    }
  }
  
  function updateScroll() {
    
    let percentScroll = (viewableHeightPc * window.scrollY);
    let pixelsScrolled = (viewableHeight * (percentScroll / 100));
    if (viewableWidth > screenWidth) {
      navScrollDiff = topNavAndHeaderHeight - (Math.round(pixelsScrolled));
    } else {
      navScrollDiff = mobileHeaderHeight - (Math.round(pixelsScrolled));
    }

    if (navScrollDiff > 0) {

      // only collapse top nav and logo when on larger screens 
      if (viewableWidth > screenWidth) {
        document.getElementById('nav-outer').style.height = (topNavAndHeaderHeight - (Math.round(pixelsScrolled)))+'px';
        searchIconHeaderAds.style.display = 'none';
      } else {
        document.getElementById('nav-outer').style.height = (mobileHeaderHeight - (Math.round(pixelsScrolled)))+'px';
      }
      document.getElementById('nav-search-outer').style.height = (navSearchHeight - (Math.round(pixelsScrolled)))+'px';
    } else {
      if (viewableWidth > screenWidth) {
        document.getElementById('nav-outer').style.height = '0px';
        searchIconHeaderAds.style.display = 'block';
      } else {
        document.getElementById('nav-outer').style.height = '0px';
      }
      document.getElementById('nav-search-outer').style.height = '0px';
    }
    document.getElementById('content').style.paddingTop = document.getElementsByTagName('header')[0].scrollHeight+'px';
    rpos = false;
  }
  
  function onScroll() {
    latestKnownScrollY = window.scrollY;
    requestPos();
  }
  
  function requestPos() {
    if(!rpos) {
      requestAnimationFrame(updateScroll);
    }
    rpos = true;
  }
  
  // only for desktop
  window.addEventListener('resize', doResize, false);
  // first time call on page load
  doResize();

  //-- END - COLLAPSE HEADER onScroll

  //-- START - OVERLAY SEARCH
  // get various elements related to search and modal

  const searchInput = document.getElementById('search-input');
  const searchInputPos = searchInput.getBoundingClientRect();
  const searchModal = document.getElementById('search-modal');
  const searchModalHeight = searchModal.style.height;
  const showOnModal = document.getElementsByClassName('show-on-modal');
  const searchBttns = document.getElementsByClassName('btn-search-icon');

  const resetOnModalClose = () => {

    Object.assign(searchModal.style, {
      position: 'relative',
      width: '100%',
      overflow: 'hidden',
      top:null,
      height: `${searchModalHeight}px`
    });

    for (let element of showOnModal) {
      element.style.display = 'none';
    }

    searchInput.value = '';
  }

  const showSearchOverlay = () => {
    if (searchModal.style.top != '0px') {
      // it's expanded so don't do the animation again
      
      // set initial styles to 'reset' the position and transform
      Object.assign(searchModal.style, {
        borderRadius: '100%',
        position: 'fixed',
        top: `${searchInputPos.y}px`,
      });
  
      // set a timeout so that the transition can be seen 
      setTimeout(() => {
  
        Object.assign(searchModal.style,{
          borderRadius:'0',
          overflow: 'scroll',
          width:`100%`,
          height: `100%`,
          top: `0px`,
          left: `0px`
        });
  
      }, 250);
  
      setTimeout(() => {
        for (let element of showOnModal) {
          element.style.display = 'flex';
        }
      }, 400);
    }
  }

  // pop open the box when click into the search field
  searchInput.addEventListener('focus',showSearchOverlay);

  // or pop open search overlay when click search buttons [header collapse/mobile]
  for (let searchBttn of searchBttns) {
    searchBttn.addEventListener('click',showSearchOverlay);
  }

  // listen for click of X on modal || press of escape key to close everything
  document.getElementById('close-search-modal').addEventListener('click', () => {
    resetOnModalClose();
  });

  document.addEventListener('keydown', (e) => {
    e = e || window.event;
    let isEscape = false;

    if ("key" in e) {
      isEscape = (e.key === "Escape" || e.key === "Esc");
    } else {
      isEscape = (e.keyCode === 27);
    }
    if (isEscape) {
      resetOnModalClose();
    }
  });

  // END - overlay search

  // MOBILE MENU - 

  let mobileMenu = document.querySelector('#menu-row'),
  mobileMenuBtn = document.querySelector('#mobile-show-menu');

  if (mobileMenu && viewableWidth <= screenWidth) {
    mobileMenuBtn.addEventListener('click', () => {
      let menuStyle = mobileMenu.style.display;
      let overlay = document.getElementById("overlay");
      overlay.addEventListener('click', function() {
        overlay.style.display = 'none';
      });

      if (menuStyle == 'block') {
        mobileMenu.style.display = 'none';
        overlay.style.display = "none";
      } else {
        mobileMenu.setAttribute('style','display:block !important');
        overlay.style.display = "block";
      }
    });
  }


});

fullWidthSwitch();
